/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import { Dropdown } from 'primereact/dropdown';
import { Sidebar } from 'primereact/sidebar';
import AddEditUser from './AddEditUser';
import { handleGetRequest } from '../../services/GetTemplate';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './UsersData.css';
import DeleteIcon from '../../assets/icons/delete.svg';
import { handleDeleteRequest } from '../../services/DeleteTemplate';
import SuccessLoader from '../../components/SuccessLoader';
import { FilterMatchMode } from 'primereact/api';

function UsersData() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState(null);
    const [editAble, setEditAble] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [roleIDOptions, setroleIDOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [globalFilter, setGlobalFilter] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 960);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 960);
        };
        
        window.addEventListener('resize', handleResize);
        
        // Initial check
        handleResize();
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

     const renderHeader = () => {
         return (
             <div className="Global__Header">
                 <span className="block mt-2 md:mt-0 p-input-icon-left">
                     <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search..."/>
                 </span>
             </div>
         );
     };

     const header = () => renderHeader();
    
    const menuRefs = useRef(new Map());

     

    const handleDelete = async (row) => {
        setIsLoading(true);
        try {
            const response = await dispatch(handleDeleteRequest(`/api/user/${row.id}`, true, true));
            if (response?.success) {
                setDeleteDialogVisible(false);
                setUserToDelete(null);
                setShowSuccess(true);

                fetchUsersData(page);

                setTimeout(() => {
                    setShowSuccess(false);
                }, 2000);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchUsersData = async (pageNumber = 1) => {
        setIsLoading(true);
        try {
            setLoading(true);
            const response = await handleGetRequest(`/api/user?page=${pageNumber}&size=${rows}`, false, false);

            if (response?.success) {
                setTableData(response?.data || []);
                setTotalRecords(response?.data[0]?.totalRows || 50);

                // setShowSuccess(true);
                setTimeout(() => {
                    setShowSuccess(false);
                }, 2000);
            }
        } catch (error) {
            console.error('Error fetching users data:', error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        fetchUsersData(newPage);
    };

    useEffect(() => {
        fetchUsersData(page);
    }, []);

    const actionBodyTemplate = (rowData) => {
        const handleEdit = (row) => {
            setSidebarVisible(true);
            setIsEditing(true);
            setEditData(row);
            setEditAble(true);
        };

        const confirmDelete = (row) => {
            setUserToDelete(row);
            setDeleteDialogVisible(true);
        };

        const items = [
            {
                label: 'Edit',
                icon: 'pi pi-pencil',
                className: ' custom-edit',
                command: () => handleEdit(rowData)
            },
            {
                label: 'Delete',
                icon: 'pi pi-trash',
                className: ' custom-delete',
                command: () => confirmDelete(rowData)
            }
        ];

        // Get or create a unique menu reference for this row
        if (!menuRefs.current.has(rowData.id)) {
            menuRefs.current.set(rowData.id, React.createRef());
        }
        const rowMenuRef = menuRefs.current.get(rowData.id);

        return isMobileView ? (
            <div className="flex gap-2">
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-text p-button-sm"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(rowData);
                    }}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-text p-button-sm p-button-danger"
                    onClick={(e) => {
                        e.stopPropagation();
                        confirmDelete(rowData);
                    }}
                />
            </div>
        ) : (
            <div>
                <Menu model={items} popup ref={rowMenuRef} />
                <Button
                    icon="pi pi-ellipsis-h"
                    className="p-button p-0 m-0 bg-white border-none shadow-none hover:bg-gray-100 custom-icon-black"
                    style={{ boxShadow: 'none' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        rowMenuRef.current.toggle(e);
                    }}
                />
            </div>
        );
    };

    const template1 = {
        layout: 'CurrentPageReport',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                    Showing{' '}
                    <span style={{ fontWeight: '700' }}>
                        {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                    </span>{' '}
                    from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> data
                </span>
            );
        }
    };

    const template2 = {
        layout: 'PrevPageLink PageLinks NextPageLink',
        PrevPageLink: (options) => {
            return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        },
        PageLinks: (options) => {
            const isActive = options.currentPage === options.page;
            return (
                <button
                    type="button"
                    className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                    onClick={options.onClick}
                    style={{
                        width: '40.08px',
                        height: '40.08px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        margin: '2px',
                        border: 'none',
                        boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                    }}
                >
                    {options.page + 1}
                </button>
            );
        },
        NextPageLink: (options) => {
            return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        }
    };

    const onHideSidebar = () => {
        setSidebarVisible(false);
        setIsEditing(false);
        setEditData(null);
        setEditAble(false);
    };

    const getRoleID = async () => {
        const response = await handleGetRequest('/api/role');
        if (response?.success) {
            const formattedOptions = response.data.map((role) => ({
                label: role.name,
                value: role.id
            }));
            setroleIDOptions(formattedOptions);
        } else {
            console.error('Failed to fetch roles:', response?.message);
        }
    };

    useEffect(() => {
        getRoleID();
    }, []);

    const handleGetRoleName = (roleID) => {
        const role = roleIDOptions.find((role) => role.value === roleID);
        return role ? role.label : 'Data Entry Operator';
    };

    return (
        <>
            {showSuccess && <SuccessLoader />}
            <ConfirmDialog
                visible={deleteDialogVisible}
                onHide={() => setDeleteDialogVisible(false)}
                message="On clicking this, user details will be removed from the system. Proceed further?"
                contentClassName="content-className"
                header="Delete User"
                headerClassName="text-black"
                icon={<img src={DeleteIcon} alt="Delete" />}
                acceptLabel="Sure"
                rejectLabel="Close"
                acceptClassName="accept-button"
                rejectClassName="reject-button"
                className="custom-confirm-dialog"
                accept={() => handleDelete(userToDelete)}
            />
            <div className="grid">
                <div className="col-12 flex flex-column">
                    <Sidebar
                        className="p-sidebar-md"
                        visible={sidebarVisible}
                        position="right"
                        onHide={onHideSidebar}
                        style={{ width: isMobileView ? '100vw' : '30rem' }}
                        fullScreen={isMobileView}
                        pt={{
                            header: { className: 'border-bottom-1' },
                            content: { className: 'p-0' }
                        }}
                        showCloseIcon={false}
                    >
                        <AddEditUser onHideSidebar={onHideSidebar} isEditing={isEditing} editData={editData} editAble={editAble} fetchUsersData={fetchUsersData} />
                    </Sidebar>
                  
                    <div className="flex flex-column sm:flex-row justify-content-between align-items-start sm:align-items-center gap-3">
                        <h2 className="text-lg font-semibold m-0">User Management</h2>
                        <Button
                            label={isMobileView ? "" : "Add New"}
                            icon="pi pi-plus"
                            className="px-3 py-2 font-semibold"
                            style={{ 
                                backgroundColor: '#FF556A', 
                                border: 'none', 
                                borderRadius: '10px', 
                                width: isMobileView ? '44px' : '150px'
                            }}
                            onClick={() => {
                                setSidebarVisible(true);
                                setIsEditing(false);
                                setEditData(null);
                                setEditAble(false);
                            }}
                        />
                    </div>
                    <div className="card mt-3 overflow-x-auto p-2 md:p-3">
                        <DataTable
                            globalFilterFields={['status', 'role', 'mobileNumber', 'email', 'createdOn']}
                            filters={filters}
                            header={header}
                            value={tableData}
                            className="datatable-responsive shadow-md rounded-xl"
                            responsiveLayout="stack"
                            breakpoint="960px"
                            loading={loading}
                            scrollable
                            style={{ minHeight: '65vh' }}
                            stickyHeader
                            resizableColumns
                            columnResizeMode="fit"
                            // showGridlines
                            // stripedRows
                        >
                            <Column
                                field="name"
                                header="Name"
                                body={(rowData) => (
                                    <div className="">
                                        <span>{rowData.name}</span>
                                    </div>
                                )}
                                style={{ minWidth: '150px' }}
                                priority="1"
                                emptyMessage={
                                    <div className="w-full text-center">
                                        No results found
                                    </div>
                                }
                            />
                            <Column field="role" header="Role" body={(rowData) => handleGetRoleName(rowData.roleID)} style={{ minWidth: '15%' }} priority="2" />
                            <Column field="mobileNumber" header="Phone number" style={{ minWidth: '140px' }} priority="3" />
                            <Column field="email" header="Email" style={{ minWidth: '30%', wordBreak: 'break-word' }} priority="2" />
                            <Column field="createdOn" header="Created On" body={(rowData) => new Date(rowData.createdOn).toLocaleDateString()} style={{ minWidth: '120px' }} priority="4" />

                            <Column
                                field="status"
                                header="Status"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${
                                            rowData.isActive === true ? 'bg-[#E6F4EA] text-[#3A974C] Active-column' : rowData.isActive === false ? 'bg-[#FFEFE9] text-[#FF8F6B] Inactive-column' : ''
                                        }`}
                                    >
                                        {rowData.isActive === true ? 'Active' : rowData.isActive === false ? 'Inactive' : ''}
                                    </div>
                                )}
                                style={{ minWidth: '100px' }}
                                priority="1"
                            />
                            <Column body={(rowData) => actionBodyTemplate(rowData)} headerClassName="text-center" style={{ minWidth: '80px', textAlign: 'center' }} priority="1" exportable={false} header="Actions" />
                        </DataTable>
                        <div className="flex flex-column md:flex-row justify-content-between mb-3 sticky" style={{borderTop: '1px solid #efefef', marginTop: '20px'}}>
                            {!isMobileView ? (
                                <>
                                    <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                                    <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                                </>
                            ) : (
                                <Paginator
                                    template={{
                                        layout: 'PrevPageLink PageLinks NextPageLink RowsPerPageDropdown',
                                        'RowsPerPageDropdown': (options) => {
                                            return (
                                                <div className="my-2">
                                                    <span className="mx-1">Items per page:</span>
                                                    <Dropdown value={options.value} options={[10, 25, 50]} onChange={options.onChange} />
                                                </div>
                                            );
                                        }
                                    }}
                                    first={first}
                                    rows={rows}
                                    totalRecords={totalRecords}
                                    onPageChange={onPageChange}
                                    className="w-full justify-content-center"
                                    rowsPerPageOptions={[10, 25, 50]}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
          
        </>
    );
}

export default UsersData;
